import { chameleonIconButton } from '../IconButton/IconButton.definition';
import { chameleonSvg } from '../Svg';
import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonCalendar } from './Calendar.definition';
import { chameleonButton } from '../Button/Button.definition';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonCalendar({ prefix }), chameleonIconButton({ prefix }), chameleonSvg({ prefix }), chameleonButton({ prefix }));
}
